module.exports = __webpack_public_path__ + "img/hillstone.f15790c5.svg";